<template>
  <div class="layout-box">
    <LayoutHeader headtitle="化纤总览"></LayoutHeader>
    <div class="secondary-content">
      <div class="secondary_l">
        <h3 style="margin-top: 55px;">化纤产品进出口</h3>
        <div id="overview-echart-one" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)" class="borderl-mian" style="height: 340px"></div>
        <div class="borderl-mian flexs" style="padding: 0 6px; padding-left: 18px; margin-top: 65px">
          <div style="width: 45%; height: 100%;" v-loading="loading4" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h4>{{ year }}年纺织服装行业需求结构</h4>
            <div id="overview-echart-five" style="height: 280px"></div>
          </div>
          <div style="width: 55%; height: 100%;" v-loading="loading4" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h4>{{ year }}年国内化纤各产品结构</h4>
            <div id="overview-echart-four" style="height: 280px"></div>
          </div>
        </div>
      </div>
      <div class="secondary_c">
        <div style="flex: 1; position: relative" v-loading="loading5" element-loading-background="rgba(0, 0, 0, 0.1)" >
          <div id="china_maps" style="width: 100%; height: 100%;"></div>
          <span style="position: absolute; top: 28px; left:0; width:100%; font-size: 21px; font-family: fzskjt; color: #fff; text-align: center">{{ year2 }}年化纤产能概览</span>
        </div>
        <div class="category-map">
          <a v-for="(item,index) in categorymap" :key="index">
            <viewer :images='[item.img]'>
              <span @click="showmaping('maping'+index)">{{ item.name }}<img style="display: none" :id='"maping"+index' :src='item.img' /></span>
            </viewer>
          </a>
        </div>
      </div>
      <div class="secondary_r">
        <h3 style="margin-top: 55px; margin-bottom: 20px">化纤产品产量</h3>
        <div id="overview-echart-two" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)" class="borderl-mian"></div>
        <h3 style="margin-top: 45px; margin-bottom: 20px">中国化学纤维产量统计情况</h3>
        <div class="legends"><em class="cn-icon"></em><span style="margin-right: 15px">产量（万吨）</span><em class="zs-icon"><i></i></em><span>增速（%）</span></div>
        <div id="overview-echart-three" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)" class="borderl-mian"></div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from '../layout/layout-header2'
import {getTime} from '../../bll/utils'
import geojson from '../../bll/china.json'

export default {
  name: 'OverviewAnalysis',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  directives:{trigger:{inserted(el,binging){el.click();}}},
  components: {
    LayoutHeader
  },
  data () {
    return {
      categorymap:[{
        name:'PTA产业链流程图',
        img:require('../../assets/img/map-pta.png')
      },{
        name:'涤纶长丝熔体直纺工艺',
        img:require('../../assets/img/map-rtzf.png')
      },{
        name:'涤纶长丝切片纺工艺',
        img:require('../../assets/img/map-csqp.png')
      }],
      year:new Date().getFullYear()-1,
      year2:'',
      loading:true,
      loading2:true,
      loading3:true,
      loading4:true,
      loading5:true,
      $_timergetdata:null,
    }
  },
  created () {
    localStorage.setItem('gotourl', window.location.hash)
  },
  mounted () {
    let $this = this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this = this
      const url = '/api-portal/chemicalFiber/industryImportExport';
      this.loading = true
      this.$api.get(url, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          $this.renderoverviewechartone(dataall.indexNames,dataall.exportValue,dataall.importValue,dataall.exportValueTb,dataall.importValueTb,'出口','进口')
        }
        this.loading = false
      })

      const url2 = '/api-portal/chemicalFiber/industryVariety';
      this.loading2 = true
      this.$api.get(url2, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          $this.drawbarchart(dataall.indexValues,dataall.indexNames)
        }
        this.loading2 = false
      })

      const url3 = '/api-portal/chemicalFiber/industryProductionStatistics';
      this.loading3 = true
      this.$api.get(url3, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          $this.drawbarchart2(dataall.indexValues,dataall.indexNames,dataall.zz)
        }
        this.loading3 = false
      })

      const url4 = '/api-portal/chemicalFiber/industryDemandProductStructure';
      this.loading4 = true
      this.$api.get(url4, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          const metricNameOne=dataall.indexNames
          const metricName=dataall.indexNamesOther
          let data1=[]
          let data2=[]
          if(metricNameOne){
            metricNameOne.map((val,index)=>{
              let nums=dataall.indexValues[index]
              let arr={
                name:val,
                value:nums.toFixed(1)
              }
              data1.push(arr)
            })
            data1.sort(function (a,b){
              return b.value-a.value
            })
            $this.renderoverviewechartfour(data1)
          }
          if(metricName){
            metricName.map((val,index)=>{
              let nums=dataall.indexValuesOther[index]
              let arr={
                name:val,
                value:nums.toFixed(1)
              }
              data2.push(arr)
            })
            $this.renderoverviewechartfive(data2)
          }
        }
        this.loading4 = false
      })

      const url5 = '/api-portal/chemicalFiber/industryMap';
      this.loading5 = true
      this.$api.get(url5, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          $this.year2=dataall[0].showYear||''
          $this.renderoverviewechartchinamap(dataall)
        }
        this.loading5 = false
      })
    },
    showmaping(name){
      document.getElementById(name).click()
    },
    renderoverviewechartone (time,data1,data2,data3,data4,name1,name2) {
      const myEchartst = this.$echarts.init(document.getElementById('overview-echart-one'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'<br/>'
              str += `${item.marker}${item.seriesName}: ${idx%2==1?item.data.toFixed(2):(item.data/1000).toFixed(1)} ${idx%2==1?'%':'万吨'}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        color:['#13C420','#FF9933','#0BA46A','#9933FF'],
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '18%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: time
        },
        yAxis: [{
          type: 'value',
          name:'万吨',
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,-40]
          },
          axisLabel: {
            color: '#C1D3F4',
            formatter: function (params) {
              return parseInt(params/1000)
            }
          },
          min:val=>{
            return parseInt(val.min/1000)*1000
          },
          splitLine:{
            show:false
          }
        },{
          type: 'value',
          name:'%',
          axisLabel: {
            color: '#C1D3F4',
          },
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,35]
          },
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          }
        }],
        series: [
          {
            name: name2,
            type: 'bar',
            stack: 'total',
            yAxisIndex:0,
            // label: {
            //   show: true
            // },
            emphasis: {
              focus: 'series'
            },
            data: data2
          },
          {
            name: name2+'同比',
            type: 'line',
            yAxisIndex:1,
            lineStyle: {
              color: '#0BA46A'
            },
            color: '#0BA46A',
            data: data4
          },
          {
            name: name1,
            type: 'bar',
            stack: 'total',
            yAxisIndex:0,
            // label: {
            //   show: true
            // },
            emphasis: {
              focus: 'series'
            },
            data: data1
          },
          {
            name: name1+'同比',
            type: 'line',
            yAxisIndex:1,
            lineStyle: {
              color: '#9933FF'
            },
            color: '#9933FF',
            data: data3
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    drawbarchart (data1,data2) {
      const myEchartst = this.$echarts.init(document.getElementById('overview-echart-two'))
      let option = {
        tooltip: {
          show: false
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '3%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: data2
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },
        series: [
          {
            name: '产量',
            type: 'bar',
            data: data1,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#00D900'
                  }, {
                    offset: 1,
                    color: '#FF7F00'
                  }
                ]
              }
            }
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    drawbarchart2 (data1,data2,data3) {
      const myEchartst = this.$echarts.init(document.getElementById('overview-echart-three'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter:function (params) {
            let str = '';
            params.forEach((item, idx) => {
              str += idx != 0? '': item.axisValue+'年<br/>'
              str += `${item.marker}${item.seriesName}: ${idx%2==1?item.data.toFixed(2):item.data.toFixed(1)} ${idx%2==1?'%':'万吨'}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
          }
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '3%',
          containLabel: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'category',
          // boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: data2
        },
        yAxis: [{
          type: 'value',
          splitLine: {
            show:false
          },
          axisLabel: {
            color: '#C1D3F4'
          }
        },{
          type: 'value',
          name:'%',
          axisLabel: {
            color: '#C1D3F4',
          },
          nameTextStyle:{
            color: '#C1D3F4',
            padding:[0,0,0,35]
          },
          splitLine: {
            lineStyle: {
              color: '#2345AB'
            }
          }
        }],
        series: [
          {
            name: '产量',
            type: 'bar',
            data: data1,
            yAxisIndex:0,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#7FFF00'
                  }, {
                    offset: 1,
                    color: '#FF00FF'
                  }
                ]
              }
            }
          },
          {
            name: '增速',
            type: 'line',
            yAxisIndex:1,
            lineStyle: {
              color: '#FFFF15',
            },
            color: '#FF7F00',
            data: data3
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    renderoverviewechartfour (data) {
      const myEchartst = this.$echarts.init(document.getElementById('overview-echart-four'))
      let option = {
        color:['#2ba346','#fed300','#ea5513','#81d8cf','#9810d1','#444A54','#EC5565','#47CEAC'],
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            let str = '';
            str += params.seriesName + '<br/>'
            str += `${params.marker}${params.name}: ${params.value} 万吨<br>`
            str +=`&nbsp;&nbsp;&nbsp;占比：${params.percent}%`
            return str
          }
        },
        legend: {
          show:false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '3%',
          containLabel: true
        },
        series: [
          {
            name: '化纤产品结构',
            type: 'pie',
            radius: '71%',
            label: {
              formatter: `{b},{d}%`,
              fontSize: 12, //字体大小
              color:'#C9DEFE'
            },
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    renderoverviewechartfive (data) {
      const myEchartst = this.$echarts.init(document.getElementById('overview-echart-five'))
      let option = {
        color:['#2ba346','#fed300','#ea5513','#81d8cf','#9810d1'],
        tooltip: {
          show:false
        },
        legend: {
          show:false
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          top: '3%',
          containLabel: true
        },
        series: [
          {
            name: '纺织服装需求结构',
            type: 'pie',
            radius: ['48%', '85%'],
            label: {
              formatter: function (params) {
                return params.name+','+params.percent.toFixed(0)+'%'
              },
              fontSize: 13, //字体大小
              color:'#fff',
              textShadowColor:'#011',
              padding:[0,0,0,20],
              textShadowBlur:5,
              position:'inner'
            },
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      myEchartst.setOption(option,true)
    },
    renderoverviewechartchinamap(data){
      const $this=this
      clearInterval($this.$_timergetdata)
      $this.$_timergetdata = null
      const myEchartst = this.$echarts.init(document.getElementById('china_maps'))
      // myEchartst.showLoading();
      this.$echarts.registerMap('china',geojson)
      // myEchartst.hideLoading();
      data.sort(function (a, b) {
        return a.value - b.value;
      });
      let showdata=data.slice(-3)
      const mapOption = {
        tooltip: {
          padding:8,
          borderWidth:1,
          borderColor:'#014BF8',
          backgroundColor:'rgba(255,255,255,0.95)',
          textStyle:{
            color:'#000000',
            fontSize:14
          },
          formatter:function (params) {
            let str = '';
            str += params.seriesName + '<br/>'
            str += `${params.marker}${params.name}: ${params.value?params.value.toFixed(2):'--'} 万吨`
            return str
          }
        },
        visualMap: {
          left: 'right',
          textStyle: {
            color:'#C1D3F4'
          },
          textareaStyle:{
            color:'#fff'
          },
          // inRange: {
          //   // prettier-ignore
          //   color: ['#DB0E2D', '#FFD038', '#3BD513', '#1EAFFD', '#43BBFD']
          // },
          pieces: [
            {gte: 3000,label: "",color: "#DB0E2D"},
            {gte: 1500,lt: 2999,label: "",color: "#FFD038"},
            {gte: 1000,lt: 1499,label: "",color: "#3BD513"},
            {gte: 50,lt: 999,label: "",color: "#029DF0"},
            {lt: 49,label: "",color: "#6DCBFE"}
          ],
          text: ['高', '低'],
          // calculable: true
        },
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        series: [
          {
            id: 'population',
            type: 'map',
            name:'产量',
            label:{
              color:'#fff',
              show:true,
              textShadowColor:'#011',
              textShadowBlur:5,
              formatter: function (params) {
                var res = ''
                if(showdata.findIndex(v => v.name == params.name)>-1){
                  res = params.name
                }
                return res;
              }
            },
            roam: true,
            map: 'china',
            animationDurationUpdate: 1000,
            universalTransition: true,
            data: data
          }
        ]
      };
      const barOption = {
        graphic: [{
          type:'image',
          silent:true,
          z: 100,
          left: 'center',
          top: 'middle',
          bounding:'all',
          style: {
            image:require('../../assets/secondary/watermark.png'),
            width:148,
            height:88
          }
        }],
        xAxis: {
          type: 'value',
          name:'万吨',
          nameTextStyle:{
            color: '#C1D3F4',
            fontSize:14,
            fontWeight:'bold'
          },
          axisLabel: {
            color: '#C1D3F4'
          },
          splitLine:{
            show:false
          },
          axisLine:{
            show:true,
            lineStyle:{
              color:'#5788EC'
            }
          }
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            rotate: 30,
            color: '#C1D3F4'
          },
          data: data.map(function (item) {
            return item.name;
          })
        },
        animationDurationUpdate: 1000,
        series: {
          type: 'bar',
          id: 'population',
          data: data.map(function (item) {
            return item.value;
          }),
          label:{
            show:true,
            position: 'right',
            color:'#C1D3F4'
          },
          itemStyle: {
            color: {
              type: 'linear',
              x: 1,
              y: 0,
              x2: 0,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: '#F0C31D'
                },{
                  offset: 0.3,
                  color: '#F0C31D'
                }, {
                  offset: 1,
                  color: '#43BBFD'
                }
              ]
            },
            fontSize:14
          },
          universalTransition: true
        }
      };
      let currentOption = mapOption;
      myEchartst.setOption(mapOption)
      $this.$_timergetdata = setInterval(function () {
        currentOption = currentOption === mapOption ? barOption : mapOption;
        myEchartst.setOption(currentOption, true);
      }, 16000);
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  overflow: auto;
  background: url("../../assets/secondary/bg-1.jpg");
}

.secondary-content{
  width: 100%;
  height: 100%;
  padding: 73px 10px 0 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.secondary-content h3{
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  box-sizing: border-box;
  margin-left: 58px;
  margin-top: 25px;
}

.secondary_l{
  width: 543px;
  height: 841px;
  background: url("../../assets/secondary/border-l.png") no-repeat center/100%;
}

.secondary_c{
  flex: 1;
  height: 810px;
  display: flex;
  flex-direction: column;
}

.secondary_r{
  width: 543px;
  height: 841px;
  background: url("../../assets/secondary/border-r.png") no-repeat center/100%;
}

.category-map{
  height: 65px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.category-map a{
  height: 65px;
  line-height: 65px;
  font-size: 21px;
  color: #fff;
  cursor: pointer;
  font-family: fzskjt;
  padding: 0 16px;
  background: url("../../assets/secondary/border-12.png") no-repeat;
  background-size: 100% 100%;
}

.borderl-mian{
  width: 100%;
  padding: 0 28px;
  box-sizing: border-box;
  height: 305px;
}

.borderl-mian h4{
  font-size: 16px;
  color: #fff;
  text-align: center;
  width: 100%;
}

.legends{
  text-align: center;
  color: #C9DEFE;
  font-size: 14px;
  margin-bottom: 12px;
}

.legends span{
  margin: 0 5px;
  display: inline-block;
  vertical-align: middle;
}

.cn-icon{
  display: inline-block;
  width: 32px;
  height: 8px;
  vertical-align: middle;
  background: linear-gradient(to right,#7FFF00,#FF00FF);
}

.zs-icon{
  position: relative;
  display: inline-block;
  width: 32px;
  height: 8px;
  text-align: center;
}

.zs-icon:after{
  content:"";
  display: inline-block;
  position: absolute;
  top:8px;
  left: 0px;
  width: 100%;
  height: 2px;
  background-color: #FFFF00;
}

.zs-icon i{
  display: inline-block;
  width: 6px;
  height: 6px;
  border: 1px solid #FF7F00;
  background: #FFFF00;
  border-radius: 50%;
}

.flexs{
  display: flex;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/views/secondary/overview-analysis.vue